<template>
    <div class="">
        <div class="video-big-box">
            <!-- banner÷ -->
            <div class="video-banner-box">
                <div class="video-banner-content">
                    <ul class="list">
                        <li><img src="../firstPage/components/banner/img/short_video_title.png" alt='版权登记'/></li>
                        <li class="title">短片&短视频征集</li>
                        <li class="text">大会时间：2020年12月3日-12月4日</li>
                        <li class="text" style="margin-top:6px">执行单位&技术支持：厦门安妮股份有限公司 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            活动地点：厦门北海湾惠龙万达嘉华酒店
                        </li>
                    </ul>
                    <img src="./images/ta.png" class="ta" alt='版权登记'/>
                </div>
            </div>
            <!-- content -->
            <div class="video-content-box">
                <div class="competition-background-box">
                    <div class="title">
                        <img src="./images/bgLeft.png" class="bgImg" alt='版权登记'/>
                        <span class="title-text">大赛背景</span>
                        <img src="./images/bgRight.png" class="bgImg" alt='版权登记'/>
                    </div>
                    <p style="text-indent:2em;">
                      为促进广播电视及网络视听节目高质量创新性发展，加强主流媒体传播力引导力影响力，不断推动创优精品节目竞相涌现，为会员单位搭建优秀案例观摩学习平台，经中国广播电视社会组织联合会同意，我会拟联合福建省广播电视局、厦门市委宣传部，面向全国各会员单位及有关机构征集微视频短视频短片作品、优秀单位及个人，12月初在厦门2020年短视频大会上组织展播展映。本届大会开展短片与短视频两大单元的推选征集，将由国内权威监管机构领导与业内学界的知名专家共同评审。短片单元分为网络电影、网络剧、电视栏目剧等专业内容，展播年度最佳摄影、剪辑、编剧、导演；短视频单元分为垂直领域、个人、技术、机构等几大类，展播最佳新闻资讯/生活/科技/文娱/人物纪录/剧情/动画/公益广告/形象宣传/MV等内容，年度最佳创作者、新锐创作者、创意剪辑及工具应用，年度最佳制作单位、传播平台、社会责任机构及MCN机构；大学生作品单独展播。各单元类别推选最佳、优秀等作品及最佳单项，颁发相应证书，促进全国影视短片、微短视频的生产创新与行业繁荣，推出思想精深、艺术精湛、制作精良的好作品以及一批优秀单位、团队与个人。
                    </p>
                </div>
                <div class="competition-condition-box">
                    <div class="title">
                        <span class="line line-left"></span>
                        <span class="title-text">参赛条件及方法</span>
                        <span class="line line-right"></span>
                    </div>
                    <ul class='list-box'>
                        <li class="wendang">
                            <img src="./images/lingdang.png" class="icon" alt='版权登记'/>
                            <p>关于短视频、短片推优展播活动的通知</p>
                            <button @click="downloadFile(0)">下载文档<img src="./images/bjt.png" class="bjt"/><img
                                    src="./images/ljt.png"
                                    class="ljt"/></button>
                        </li>
                        <li class="shenbao">
                            <img src="./images/zuopin.png" class="icon" alt='版权登记'/>
                            <p>作品类（年度最佳）展播推荐申报表</p>
                            <button @click="downloadFile(1)">下载申报表<img src="./images/bjt.png" class="bjt" alt='版权登记'/><img
                                    src="./images/ljt.png"
                                    class="ljt"/></button>
                        </li>
                        <li class="shenbao">
                            <img src="./images/geren.png" class="icon" alt='版权登记'/>
                            <p>个人类（年度最佳）展播推荐申报表</p>
                            <button @click="downloadFile(2)">下载申报表<img src="./images/bjt.png" class="bjt" alt='版权登记'/><img
                                    src="./images/ljt.png"
                                    class="ljt"/></button>
                        </li>
                        <li class="shenbao" style="margin:0">
                            <img src="./images/danwei.png" class="icon" alt='版权登记'/>
                            <p>单位类（年度最佳）展播推荐申报表</p>
                            <button @click="downloadFile(3)">下载申报表<img src="./images/bjt.png" class="bjt" alt='版权登记'/><img
                                    src="./images/ljt.png"
                                    class="ljt" alt='版权登记'/></button>
                        </li>
                    </ul>
                </div>
                <div class="competition-me-box">
                    <div class="title">
                        <span class="line line-left"></span>
                        <span class="title-text">我要参会</span>
                        <span class="line line-right"></span>
                    </div>
                    <ul class="competition-list-box">
                        <li class="meiti">
                            <img src="./images/meitiText.png" alt='版权登记'/>
                            <p>我是媒体</p>
                            <a @click="shortVideoClick('2')" class="meitiColor">申请</a>
                        </li>
                        <li class="guanzhong">
                            <img src="./images/guanzhongText.png" alt='版权登记'/>
                            <p>我是观众</p>
                            <a @click="shortVideoClick('3')" class="guanzhongColor">申请</a>
                        </li>
                        <li class="canzhan" style="margin:0">
                            <img src="./images/canzhanText.png" alt='版权登记'/>
                            <p>我要参展</p>
                            <a @click="shortVideoClick('1')" class="canzhanColor">申请</a>
                        </li>
                    </ul>
                </div>
                <div class="setting-prize-box">
                    <div class="setting-prize-content">
                        <div class="title">
                            <span class="line line-left"></span>
                            <span class="title-text">奖项设置</span>
                            <span class="line line-right"></span>
                        </div>
                        <div class="setting-prize-tab">
                            <ul class="tab-tilte">
                                <li @click="cur=0" :class="{active:cur==0}" style="margin-right:32px">短片单元</li>
                                <li @click="cur=1" :class="{active:cur==1}">短视频单元</li>
                            </ul>

                            <!-- 短片单元 -->
                            <div class="tab-content">
                                <div class="carousel-list" v-if="cur==0">
                                    <el-carousel height="736px" :autoplay-speed="4000" :interval="4000"
                                                 indicator-position="outside" trigger="click" autoplay>
                                        <el-carousel-item v-for="(item,index) in shortFilm" :key="index" dots="outside">
                                            <ul style="width:1334px;padding:0 66px;box-sizing:border-box">
                                                <li v-for="(item2,index2) in item.content">
                                                    <div>
                                                        <img src="./images/jiangLogo.png" alt='版权登记'/>
                                                        <p class="title">年度最佳</p>
                                                        <p class="text">{{item2.name}}</p>
                                                    </div>
                                                </li>
                                            </ul>
                                        </el-carousel-item>
                                    </el-carousel>
                                </div>

                                <!-- 短视频单元 -->
                                <div class="carousel-list" v-if="cur==1">
                                    <el-carousel height="736px" :autoplay-speed="4000" :interval="4000"
                                                 indicator-position="outside" trigger="click">
                                        <el-carousel-item v-for="(item,index) in shortVideo" :key="index">
                                            <ul style="width:1334px;padding:0 66px;box-sizing:border-box">
                                                <li v-for="(item2,index2) in item.content">
                                                    <div>
                                                        <img src="./images/jiangLogo.png" alt='版权登记'/>
                                                        <p class="title">年度最佳</p>
                                                        <p class="text">{{item2.name}}</p>
                                                    </div>
                                                </li>
                                            </ul>
                                        </el-carousel-item>
                                    </el-carousel>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- 报名弹框 -->
        <generalframe @fatherMethod="shortVideoModelFather" v-show="shortVideoModelStatus" mywidth="644" myheight="578"
                      myTitleheight="60" :maintitle="shortVideoTitle" ref="mychild" :tishihide="false">
            <div class="short_video_model">
                <!--     我要参展       -->
                <Form v-show="shortVideoType == '1' " :model="shortVideoFrom"
                      :rules="ruleExhibition"
                      :hide-required-mark="true"
                      :label-width="120"
                      ref="formExhibition">
                    <FormItem prop="name" class="short_video_model_form_item" label="单位名称：">
                        <Input v-model="shortVideoFrom.name" class="short_video_model_form_item_input"
                               placeholder="请输入单位名称"></Input>
                    </FormItem>

                    <FormItem prop="contactName" class="short_video_model_form_item" label="参会联系人：">
                        <Input v-model="shortVideoFrom.contactName" class="short_video_model_form_item_input"
                               placeholder="请输入参会联系人"></Input>
                    </FormItem>

                    <FormItem prop="position" class="short_video_model_form_item" label="联系人职务：">
                        <Input v-model="shortVideoFrom.position" class="short_video_model_form_item_input"
                               placeholder="请输入联系人职务"></Input>
                    </FormItem>

                    <FormItem prop="contactPhone" class="short_video_model_form_item" label="联系人电话：">
                        <Input v-model="shortVideoFrom.contactPhone" class="short_video_model_form_item_input"
                               maxlength="11"
                               placeholder="请输入联系人电话"></Input>
                    </FormItem>

                    <FormItem prop="remark" class="short_video_model_form_item" label="主营业务：">
                        <Input v-model="shortVideoFrom.remark" class="short_video_model_form_item_input" type="textarea"
                               :rows="4" :autosize="{maxRows:4,minRows: 4}" placeholder="请输入主营业务"></Input>
                    </FormItem>
                </Form>

                <!--     我是媒体       -->
                <Form v-show="shortVideoType == '2' " :model="shortVideoFrom"
                      :rules="ruleMedia"
                      :hide-required-mark="true"
                      :label-width="120"
                      ref="formMedia">
                    <FormItem prop="name" class="short_video_model_form_item" label="机构/单位名称：">
                        <Input v-model="shortVideoFrom.name" class="short_video_model_form_item_input"
                               placeholder="请输入机构/单位名称"></Input>
                    </FormItem>

                    <FormItem prop="contactName" class="short_video_model_form_item" label="参会联系人：">
                        <Input v-model="shortVideoFrom.contactName" class="short_video_model_form_item_input"
                               placeholder="请输入参会联系人"></Input>
                    </FormItem>

                    <FormItem prop="position" class="short_video_model_form_item" label="联系人职务：">
                        <Input v-model="shortVideoFrom.position" class="short_video_model_form_item_input"
                               placeholder="请输入联系人职务"></Input>
                    </FormItem>

                    <FormItem prop="contactPhone" class="short_video_model_form_item" label="联系人电话：">
                        <Input v-model="shortVideoFrom.contactPhone" class="short_video_model_form_item_input"
                               maxlength="11"
                               placeholder="请输入联系人电话"></Input>
                    </FormItem>

                    <FormItem prop="remark" class="short_video_model_form_item" label="所属行业：">
                        <Input v-model="shortVideoFrom.remark" class="short_video_model_form_item_input" type="textarea"
                               :rows="4" :autosize="{maxRows:4,minRows: 4}" placeholder="请输入所属行业"></Input>
                    </FormItem>
                </Form>

                <!--     我是观众       -->
                <Form v-show="shortVideoType == '3' " :model="shortVideoFrom"
                      :rules="ruleAudience"
                      :hide-required-mark="true"
                      :label-width="120"
                      ref="formAudience">
                    <FormItem prop="name" class="short_video_model_form_item" label="单位名称：">
                        <Input v-model="shortVideoFrom.name" class="short_video_model_form_item_input"
                               placeholder="请输入单位名称"></Input>
                    </FormItem>

                    <FormItem prop="contactName" class="short_video_model_form_item" label="参会人名称：">
                        <Input v-model="shortVideoFrom.contactName" class="short_video_model_form_item_input"
                               placeholder="请输入参会人名称"></Input>
                    </FormItem>

                    <FormItem prop="contactPhone" class="short_video_model_form_item" label="联系方式：">
                        <Input v-model="shortVideoFrom.contactPhone" class="short_video_model_form_item_input"
                               maxlength="11"
                               placeholder="请输入联系方式"></Input>
                    </FormItem>

                    <FormItem prop="remark" class="short_video_model_form_item" label="参会目的：">
                        <Input v-model="shortVideoFrom.remark" class="short_video_model_form_item_input" type="textarea"
                               :rows="4" :autosize="{maxRows:4,minRows: 4}" placeholder="请输入参会目的"></Input>
                    </FormItem>
                </Form>


                <button @click="shortVideoModelSubmit" :disabled="shortVideoDisabled" class="short_video_model_submit">
                    确认提交
                </button>
            </div>

        </generalframe>
    </div>

</template>

<script>
    import {_cmsVideoConferenceGuestsJoin} from '@/api/staticPage.js'
    import '@/plugins/element.js';
    import generalframe from '@/views/vipClip/vip/lawcomponent/generalframe.vue'

    export default {
        name: 'videoDetail',
        components: {
            generalframe
        },
        data() {
            return {
                cur: 0, //默认选中第一个tab
                shortVideoModelStatus: false,
                shortVideoType: '1',
                shortVideoTitle: '',
                shortVideoFrom: {
                    name: '',
                    contactName: '',
                    contactPhone: '',
                    position: '',
                    remark: '',
                    platform: 'bqj',
                    type: ''
                },
                ruleExhibition: {
                    name: [
                        {required: true, message: '单位名称不能为空', trigger: 'blur'}
                    ],
                    contactName: [
                        {required: true, message: '参会联系人不能为空', trigger: 'blur'},
                    ],
                    position: [
                        {required: true, message: '联系人职务不能为空', trigger: 'blur'}
                    ],
                    contactPhone: [
                        {required: true, message: '联系人电话不能为空', trigger: 'blur'},
                        {pattern: /^1[3456789]\d{9}$/, message: "联系人电话格式不正确", trigger: "blur"}
                    ],
                    remark: [
                        {required: true, message: '主营业务不能为空', trigger: 'blur'},

                    ]
                },
                ruleMedia: {
                    name: [
                        {required: true, message: '机构/单位不能为空', trigger: 'blur'}
                    ],
                    contactName: [
                        {required: true, message: '参会联系人不能为空', trigger: 'blur'},
                    ],
                    position: [
                        {required: true, message: '联系人职务不能为空', trigger: 'blur'}
                    ],
                    contactPhone: [
                        {required: true, message: '联系人电话不能为空', trigger: 'blur'},
                        {pattern: /^1[3456789]\d{9}$/, message: "联系人电话格式不正确", trigger: "blur"}
                    ],
                    remark: [
                        {required: true, message: '所属行业不能为空', trigger: 'blur'},

                    ]
                },
                ruleAudience: {
                    name: [
                        {required: true, message: '单位名称不能为空', trigger: 'blur'}
                    ],
                    contactName: [
                        {required: true, message: '参会人名称不能为空', trigger: 'blur'},
                    ],
                    contactPhone: [
                        {required: true, message: '联系方式不能为空', trigger: 'blur'},
                        {pattern: /^1[3456789]\d{9}$/, message: "联系人方式格式不正确", trigger: "blur"}
                    ],
                    remark: [
                        {required: true, message: '参会目的不能为空', trigger: 'blur'},

                    ]
                },
                shortVideoDisabled: false,
                downloadFileList: [
                    'https://shortvideo-handou.oss-cn-beijing.aliyuncs.com/7e0cd9e0f5fc41d6b4816189db585e19.doc',
                    'https://shortvideo-handou.oss-cn-beijing.aliyuncs.com/default/publicdoc/作品类展播推荐申报表.docx',
                    'https://shortvideo-handou.oss-cn-beijing.aliyuncs.com/default/publicdoc/个人类（年度最佳）展播推荐申报表.docx',
                    'https://shortvideo-handou.oss-cn-beijing.aliyuncs.com/default/publicdoc/单位类（年度最佳）展播推荐申报表.docx'
                ], //下载文件列表
                shortFilm: [
                    {
                        content: [
                            {name: "网络电影"},
                            {name: "短剧"},
                            {name: "栏目剧"},
                            {name: "组织机构"},
                            {name: "摄影"},
                            {name: "剪辑"},
                            {name: "编剧"},
                            {name: "导演"}

                        ]
                    }
                ],//短片单元
                shortVideo: [
                    {
                        content: [
                            {name: "新闻资讯类作品"},
                            {name: "生活类作品"},
                            {name: "科技类作品"},
                            {name: "文娱类作品"},
                            {name: "人物纪录作品"},
                            {name: "剧情类作品"},
                            {name: "动画类作品"},
                            {name: "公益广告作品"}
                        ]
                    },
                    {
                        content: [
                            {name: "形象宣传作品"},
                            {name: "MV"},
                            {name: "组织机构"},
                            {name: "创作者"},
                            {name: "新锐创作者"},
                            {name: "创意剪辑及工具应用"},
                            {name: "制作单位"},
                            {name: "传播平台"}
                        ]
                    },
                    {
                        content: [
                            {name: "社会责任机构"},
                            {name: "MCN机构"}
                        ]
                    }
                ], //短视频单元


            }
        },
        watch: {},
        methods: {

            /**********短视频大赛模态框显示状态********/
            shortVideoModelFather() {
                this.$refs['formExhibition'].resetFields();
                this.$refs['formMedia'].resetFields();
                this.$refs['formAudience'].resetFields();
                this.$nextTick(() => {
                    this.shortVideoModelStatus = !this.shortVideoModelStatus;
                })
            },

            /**********短视频大赛点击********/
            shortVideoClick(type) {
                this.shortVideoType = type;
                this.shortVideoTitle = type == '1' ? '我要参展' : type == '2' ? '我是媒体' : '我是观众';
                this.shortVideoModelFather();


            },

            /**********短视频大赛模态框提交事件********/
            shortVideoModelSubmit() {
                let shortVideoType = this.shortVideoType;
                let shortVideoTypeName = shortVideoType == '1' ? 'formExhibition' : shortVideoType == '2' ? 'formMedia' : 'formAudience';

                this.$refs[shortVideoTypeName].validate((valid) => {
                    if (valid) {
                        this.shortVideoDisabled = true;
                        this.shortVideoFrom['type'] = shortVideoType;
                        _cmsVideoConferenceGuestsJoin(this.shortVideoFrom).then(res => {
                            console.log(res);
                            if (res.code == 200) {
                                toast('报名成功');
                                this.shortVideoDisabled = false;
                                this.shortVideoModelFather();
                            } else {
                                this.shortVideoDisabled = false;
                                toast(res.message);
                            }
                        })
                    } else {
                        this.shortVideoDisabled = false;

                    }
                })
            },

            /**********下载文件方法********/
            downloadFile(index) {
                let downloadFileList = this.downloadFileList;
                window.open(downloadFileList[index])
            }
        },
        mounted() {
        }
    }
</script>

<style scoped lang="less">
    .video-big-box {
        width: 100%;
        height: 100%;

        .video-banner-box {
            width: 100%;
            height: 460px;
            background: #1F47C1;

            .video-banner-content {
                width: 1334px;
                margin: auto;
                position: relative;

                .ta {
                    width: 1059px;
                    height: 460px;
                    position: absolute;
                    right: 0;
                    top: 0;
                }

                .list {
                    .title {
                        font-size: 40px;
                        font-weight: 500;
                        color: #FFFFFF;
                        line-height: 59px;
                        margin-bottom: 64px;
                    }

                    .text {
                        font-size: 14px;
                        font-weight: 400;
                        color: #FFFFFF;
                        line-height: 20px;
                    }

                    li {
                        list-style: none;

                        img {
                            width: 465px;
                            height: 106px;
                            margin: 94px 0 24px 0;
                        }
                    }
                }
            }
        }

        .video-content-box {
            // width: 1200px;
            // margin: auto;
            .title-text {
                font-size: 24px;
                font-weight: 500;
                color: #212121;
                margin: 0 16px;
                vertical-align: middle;
            }

            .line {
                display: inline-block;
                width: 60px;
                height: 4px;
                border-radius: 2px;
            }

            .line-left {
                background: linear-gradient(270deg, #1F47C1 0%, rgba(66, 125, 226, 0) 100%);
            }

            .line-right {
                background: linear-gradient(270deg, rgba(66, 125, 226, 0) 0%, #1F47C1 100%);
            }

            .competition-background-box {
                padding-top: 52px;
                padding-bottom: 60px;
                width: 1200px;
                margin: auto;

                .title {
                    margin: 0 auto 28px;
                    width: 250px;

                    .bgImg {
                        width: 60px;
                        height: 4px;
                        vertical-align: middle;
                    }

                }

                .text {
                    font-size: 14px;
                    color: #212121;
                    line-height: 28px;
                    text-indent: 28px;
                }
            }

            .competition-condition-box {
                width: 1200px;
                margin: auto;

                .title {
                    margin: 0 auto 28px;
                    width: 335px;
                }

                .list-box {
                    display: flex;

                    li {
                        width: 283px;
                        height: 283px;
                        background-repeat: round;
                        flex: 1;
                        margin-right: 22px;
                        list-style: none;

                        .icon {
                            width: 60px;
                            height: 60px;
                            margin: 44px auto 30px;
                            display: block;
                        }

                        p {
                            font-size: 18px;
                            font-weight: 600;
                            color: #FFFFFF;
                            line-height: 25px;
                            margin: 0 51px 34px;
                        }

                        button {
                            width: 112px;
                            height: 25px;
                            border-radius: 15px;
                            border: 1px solid #FFFFFF;
                            background: transparent;
                            line-height: 25px;
                            text-align: center;
                            font-size: 12px;
                            color: #FFFFFF;
                            cursor: pointer;
                            display: block;
                            margin: auto;
                            vertical-align: middle;
                            outline: none;

                            &:hover {
                                color: #0091FF;
                                background: #fff;

                                .bjt {
                                    width: 13px;
                                    height: 13px;
                                    margin-left: 6px;
                                    vertical-align: middle;
                                    display: none;
                                }

                                .ljt {
                                    width: 13px;
                                    height: 13px;
                                    margin-left: 6px;
                                    vertical-align: middle;
                                    display: inline-block;
                                }
                            }

                            .bjt {
                                width: 13px;
                                height: 13px;
                                margin-left: 6px;
                                vertical-align: middle;
                                display: inline-block;
                            }

                            .ljt {
                                width: 13px;
                                height: 13px;
                                margin-left: 6px;
                                vertical-align: middle;
                                display: none;
                            }
                        }
                    }

                    .wendang {
                        background-image: url('./images/wendang.png')
                    }

                    .shenbao {
                        background-image: url('./images/shenbao.png')
                    }
                }
            }

            .competition-me-box {
                width: 1200px;
                margin: auto;
                padding-top: 40px;
                padding-bottom: 40px;

                .title {
                    margin: 20px auto 28px;
                    width: 250px;
                }

                .competition-list-box {
                    display: flex;

                    li {
                        flex: 1;
                        margin-right: 48px;
                        width: 368px;
                        height: 159px;
                        background-repeat: round;
                        position: relative;
                        list-style: none;

                        img {
                            width: 299px;
                            height: 66px;
                            position: absolute;
                            left: 37px;
                            top: 12px;
                        }

                        p {
                            font-size: 24px;
                            font-weight: 500;
                            color: #FFFFFF;
                            line-height: 33px;
                            margin-top: 49px;
                            margin-left: 37px;
                            margin-bottom: 24px;
                        }

                        a {
                            width: 92px;
                            height: 25px;
                            // background: #FFFFFF;
                            border-radius: 15px;
                            border: 1px solid #FFFFFF;
                            display: block;
                            line-height: 25px;
                            text-align: center;
                            margin-left: 37px;
                            font-size: 12px;
                            color: #FFFFFF;
                        }

                        .meitiColor {
                            &:hover {
                                color: #18BA76;
                                background: #FFFFFF;
                            }
                        }

                        .guanzhongColor {
                            &:hover {
                                color: #FF5C5C;
                                background: #FFFFFF;
                            }
                        }

                        .canzhanColor {
                            &:hover {
                                color: #866CFE;
                                background: #FFFFFF;
                            }
                        }
                    }

                    .meiti {
                        background-image: url('./images/meiti.png')
                    }

                    .guanzhong {
                        background-image: url('./images/guanzhong.png')
                    }

                    .canzhan {
                        background-image: url('./images/canzhan.png')
                    }
                }
            }

            .setting-prize-box {
                // width: 1200px;
                // margin: auto;
                // background: #234DCB;
                // opacity: 0.04;
                background: rgba(35, 77, 203, 0.04);
                padding: 60px 0 52px;
                box-sizing: border-box;

                .setting-prize-content {
                    width: 1334px;
                    margin: auto;
                }

                .title {
                    margin: 0px auto 28px;
                    width: 250px;
                }

                .setting-prize-tab {
                    .tab-tilte {
                        // width: 90%;
                        width: 260px;
                        height: 30px;
                        margin: 0 auto 28px;
                    }

                    .tab-tilte li {
                        float: left;
                        // width: 25%;
                        width: 114px;
                        height: 30px;
                        line-height: 30px;
                        list-style: none;
                        // padding: 10px 0;
                        border-radius: 15px;
                        border: 1px solid #E5E5E5;
                        font-size: 14px;
                        color: #989898;
                        text-align: center;
                        // background-color:#f4f4f4;
                        cursor: pointer;
                    }

                    /* 点击对应的标题添加对应的背景颜色 */

                    .tab-tilte .active {
                        background: linear-gradient(90deg, #0091FF 0%, #00C3FF 100%);
                        border-radius: 15px;
                        color: #fff;
                    }

                    .tab-content {
                        /*clear: both;*/

                        .carousel-list {
                            // margin: 0 280px;
                            // width: 1200px;
                            margin: 0 auto;
                            /deep/ .el-carousel__arrow--left{
                                left:0;
                            }
                            /deep/ .el-carousel__arrow{
                                width: 28px;
                                height: 28px;
                            }
                            /deep/ .el-carousel__arrow--right{
                                right: 0;
                            }
                            ul {
                                display: flex;
                                flex-wrap: wrap;

                                li:nth-child(4n) {
                                    margin-right: 0;
                                }

                                li {
                                    width: 282px;
                                    height: 327px;
                                    background: #fff;
                                    padding-top: 15px;
                                    box-sizing: border-box;
                                    list-style: none;
                                    /*flex: 1;*/
                                    margin-top: 24px;
                                    margin-right: 24px;

                                    div {
                                        background-image: url('./images/jiangBox.png');
                                        background-repeat: round;
                                        width: 248px;
                                        height: 297px;
                                        margin: 0 auto;
                                        padding-top: 61px;
                                        box-sizing: border-box;

                                        img {
                                            width: 164px;
                                            height: 54px;
                                            display: block;
                                            margin: 0 auto;
                                          object-fit: contain;
                                          object-fit: contain;
                                        }

                                        .title {
                                            font-size: 18px;
                                            color: #212121;
                                            line-height: 25px;
                                            text-align: center;
                                            margin-top: 44px;
                                            margin-bottom: 0;
                                        }

                                        .text {
                                            font-size: 24px;
                                            font-weight: 600;
                                            color: #212121;
                                            line-height: 33px;
                                            margin: 0px auto;
                                            margin-top: 14px;
                                            text-align: center;
                                            width: 70%;
                                            height: 80px;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    .tab-content div {
                        // margin:28px 280px 0;
                    }
                }
            }
        }
    }

    .short_video_model {
        padding: 40px 44px 40px 50px;

        .short_video_model_form_item {
            /*margin-bottom: 16px;*/


            /deep/ .ivu-form-item-label {
                color: #212121;
                font-size: 14px;
                margin-top: 5px;
            }

            .short_video_model_form_item_input {

                /deep/ .ivu-input {
                    height: 44px;
                    border: 1px solid #E5E5E5;
                }
            }
        }


        .short_video_model_submit {
            width: 160px;
            height: 44px;
            line-height: 44px;
            box-sizing: border-box;
            background: #FFD800;
            border-radius: 4px;
            text-align: center;
            cursor: pointer;
            color: #2B2146;
            font-size: 14px;
            font-weight: 500;
            margin: 30px auto 0;
            outline: none;
            border: none;
        }
    }
</style>